module.exports = __webpack_public_path__ + "img/fox.6e81bdb2.png";